import React from "react";
import { Feature1, Feature2, Feature3, Feature4 } from "../../constant/Index";
import { useFeatureContentQuery } from "../../store/services/FeatureService";
import { useSiteContentQuery } from "../../store/services/SitesettingService";
import { Link } from "react-router-dom";

const Features = () => {
	const { data, FeatureisLoading } = useFeatureContentQuery();
	const { data: SiteData, isLoading: SiteLoading } = useSiteContentQuery();
	let Siteresponse = SiteData?.response?.data[0];
	let response = data?.response?.data;
	console.log(response);
	const Features = [
		{
			id: 0,
			FeatureImg: Feature1,
			FeatureName: "PLACE NFT AS COLLATERAL",
			FeatureContent:
				"The collateral price is determined by the NFT Floor value.",
		},
		{
			id: 1,
			FeatureImg: Feature2,
			FeatureName: "NFT PROTECTION",
			FeatureContent:
				"We create a blockchain-backed unique identity that cannot be replicated or theft.",
		},
		{
			id: 2,
			FeatureImg: Feature3,
			FeatureName: "EXCLUSIVE OFFERINGS",
			FeatureContent:
				"LMT collectors can yield maximum benefits through our exclusive deals.",
		},
		{
			id: 3,
			FeatureImg: Feature4,
			FeatureName: "LIQUIDATE YOUR ASSETS",
			FeatureContent:
				"Access the liquidity whenever you need it without selling your assets.",
		},
	];
	return (
		<>
			{/* <!-- Our Feature Sec Start Here --> */}
			<section className="our_features">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<div className="content-wrapper">
								<div className="glowing glowing-one">
									<span></span>
									<span></span>
								</div>
								<h4 className="wow animate__animated animate__fadeInDown">
									Lend Me Token
								</h4>
								<h2 className="wow animate__animated animate__fadeInDown animate__delay-1s">
									{Siteresponse?.title}
								</h2>
								<p
									dangerouslySetInnerHTML={{
										__html: Siteresponse?.description,
									}}
									className="wow animate__animated animate__fadeInDown animate__delay-2s"
								></p>
								<div className="button-group mt-5 wow animate__animated animate__fadeInUp animate__delay-3s">
									<Link to="/feature" className="buy-btn blue">
										<span className="txt">View All</span>
										<span className="svg-icon">
											<svg width="28" height="28" viewBox="0 0 28 28">
												<defs>
													<filter
														id="Ellipse_15"
														x="0"
														y="0"
														width="28"
														height="28"
														filterUnits="userSpaceOnUse"
													>
														<feOffset dy="2" input="SourceAlpha" />
														<feGaussianBlur stdDeviation="1" result="blur" />
														<feFlood floodOpacity="0.302" />
														<feComposite operator="in" in2="blur" />
														<feComposite in="SourceGraphic" />
													</filter>
												</defs>
												<g
													id="Group_27"
													data-name="Group 27"
													transform="translate(-340 -668)"
												>
													<g
														transform="matrix(1, 0, 0, 1, 340, 668)"
														filter="url(#Ellipse_15)"
													>
														<circle
															id="Ellipse_15-2"
															data-name="Ellipse 15"
															cx="11"
															cy="11"
															r="11"
															transform="translate(3 1)"
															fill="#f9f928"
														/>
													</g>
													<path
														id="Path_16"
														data-name="Path 16"
														d="M585.823,402.516a.646.646,0,0,1-.556-.634c0-.054,0-.107,0-.161q0-3.333,0-6.665a1.178,1.178,0,0,1,.069-.419.626.626,0,0,1,.806-.343,2.325,2.325,0,0,1,.541.217q2.694,1.538,5.38,3.087a1.207,1.207,0,0,1,.509.48.736.736,0,0,1-.262.933,2.108,2.108,0,0,1-.255.17l-5.37,3.085a1.994,1.994,0,0,1-.669.249Z"
														transform="translate(-233.954 281.611)"
														fill="#d13900"
													/>
												</g>
											</svg>
										</span>
									</Link>
								</div>
							</div>
						</div>
						<div className="col-lg-8">
							<div className="row">
								{response?.slice(0, 4)?.map((data) => {
									return (
										<div className="col-md-6" key={data?.id}>
											<div
												className={
													"feature-box wow animate__animated animate__bounceIn"
												}
											>
												<div className="icon-box">
													<figure>
														<img
															src={data?.image_path}
															alt="123"
															className="img-fluid"
														/>
													</figure>
												</div>
												<div className="txt">
													<h3>{data?.title}</h3>
													<p
														dangerouslySetInnerHTML={{
															__html: data?.description,
														}}
													>
														{data?.FeatureContent}
													</p>
												</div>
											</div>
										</div>
									);
								})}
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* <!-- Our Feature Sec End Here --> */}
		</>
	);
};

export default Features;
